import './simple-color-picker.scss';

import SimpleColorPicker from './SimpleColorPicker';

export default SimpleColorPicker;
